export function interpolateUrlVariables(url = '', config) {
    const userName = config.showpadUser && config.showpadUser.userName ? config.showpadUser.userName : '';
    const email = config.showpadUser && config.showpadUser.userEmail ? config.showpadUser.userEmail : '';
    return url.replace('[username]', userName).replace('[email]', email);
}
//# sourceMappingURL=UrlHelper.js.map